const applicant2Transition = 'APPLICANT_2_TRANSITION';
const applicant2Name = 'APPLICANT_2_NAME';
const applicant2Email = 'APPLICANT_2_EMAIL';

export default {
  applicant2Transition,
  applicant2Name,
  applicant2Email,
};
